import { Button, Group, Iframe, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useTheme } from "@/comn/hooks";
import { APIS, SF_EWC_SRCH } from "@/tra/tancis/ptli/temp/dw/services/TdwiDwService";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

/*
 * DW Iframe Page
 * !== DW Ifame Page ==!
 */
export const EWCI1001001Q = () => {
    const { pgeUid, menuId } = usePage({
            auth: ["auth_ptli0015", "auth_ptlianyADM"],
        });
    const modal = useModal();
    const { t } = useTranslation();
    const ewacsOptions: any = [
        {
            label: "kube-system",
            value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_KUBESYSTEM}`,
        },
        // {
        //     label: "ai",
        //     value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_AI}`,
        // },
        {
            label: "build",
            value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_BUILD}`,
        },
        {
            label: "monitoring",
            value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_MONITORING}`,
        },
        {
            label: "tancis-batch",
            value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_TANCISBATCH}`,
        },
        {
            label: "tancis-ext",
            value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_TANCISEXT}`,
        },
        {
            label: "tancis-int",
            value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_TANCISINT}`,
        },
        // {
        //     label: "wso2",
        //     value: `${process.env.REACT_APP_GRAFANA_EWCI1001001Q}${process.env.REACT_APP_GRAFANA_EWCI1001001Q_WSO2}`,
        // },
    ];

    const [iframeSrc, setIframeSrc] = useState("");

    const form = {
        ewcSrch: useForm({ defaultSchema: SF_EWC_SRCH }),
    };

    const handler = {
        handleChange: (v: any) => {
            setIframeSrc(v);
        },
    };

    useEffect(() => {
        setIframeSrc(ewacsOptions[0].value);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.ewcSrch.schema.ewacType}
                                options={ewacsOptions}
                                onChange={handler.handleChange}
                                //value={ewacsOptions[0].value}
                            />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {iframeSrc && (
                <Group>
                    <Group.Body>
                        <Iframe src={iframeSrc} height={800} />
                    </Group.Body>
                </Group>
            )}
        </Page>
    );
};
